var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"games-parent"},_vm._l((_vm.games),function(game){return _c('div',{key:game.appid},[_c('Game',{attrs:{"game":game}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }